<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-25                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-card no-body>
    <b-card-header header-bg-variant="info" header-text-variant="white"> <span class="font-weight-bold">Selection Summary</span></b-card-header>
    <b-card-body class="p-0" style="max-height: 400px;overflow-y: auto">
      <b-list-group v-for="category_object in selected_nodes_by_category_name" :key="category_object.id">
        <b-list-group-item>
          <b-badge variant="info" class="mx-3">{{category_object.category_node.name}}</b-badge>
        </b-list-group-item>
        <b-list-group-item v-for="node in category_object.nodes" :key="node.id"
                           class="px-3 py-1 d-flex justify-content-between">
          <span>{{node.name}}</span>
          <span>
            <b-badge v-if="getNodePrice(node) !== 0">{{formatCurrency(getNodePrice(node))}}</b-badge>
          </span>
        </b-list-group-item>
      </b-list-group>

    </b-card-body>
  </b-card>
</template>

<script>
import ConfigurationTemplateVersion from "../../business-objects/configuration-template-version";
import YesNo from "../../enums/yes-no";
import IsSelected from "../../enums/is-selected";
import QuoteProduct from "../../business-objects/quote-product";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";

export default {
  name: "product-category-product-summary",
  props: {
    templateVersion: {
      type: ConfigurationTemplateVersion,
      required: true
    },
    priceName:{
      type:String,
      required: true
    },
    quoteProduct:{
      type: QuoteProduct,
      required: true
    }
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  data(){
    return {
    };
  },
  computed: {
    summary_nodes() {
      return this.templateVersion.selected_nodes
          .filter((node) => {
            return node.attribute_store['item-type'] === 'content' &&
                node.attribute_store['hide-on-summary'] !== YesNo.YES;
          })
          .sort((node1, node2) => {
            if (node1.attribute_store['category-order'] < node2.attribute_store['category-order']) {
              return -1;
            }
            if (node1.attribute_store['category-order'] > node2.attribute_store['category-order']) {
              return 1;
            }
            return 0;
          });
    },
    sorted_selected_nodes(){
      return this.templateVersion.selected_nodes
          .sort((node1,node2)=>{
            if(node1.attribute_store['category-order'] < node2.attribute_store['category-order']){
              return -1;
            }
            if(node1.attribute_store['category-order'] > node2.attribute_store['category-order']){
              return 1;
            }
            return 0;
          });
    },
    selected_nodes_by_category_name(){
      return this.sorted_selected_nodes.reduce((object, node) => {
        let category_name = node.attribute_store['category'];
        if(!object[category_name]){
          let category_node = this.templateVersion.nodes.find((node) => {
            return node.attribute_store['item-type'] === 'category' && node.attribute_store['category'] === category_name;
          });
          object[category_name] = {category_node:category_node,nodes:[]};
        }
        object[category_name].nodes.push(node);
        return object;
      }, {});
    }
  },
  methods:{
    getNodePrice(node){
      let price = node.calculated_price_transformations[this.priceName];
      if(price === undefined || price === null){
        price = '0';
      }
      return parseFloat(price);
    }
  }
}
</script>

<style scoped>

</style>
